<template>
  <div id="limitScroll">
    <div class="wrapper">
    <section id="limitBox">
      <div class="limitWrapper">
    <div class="output">

      Кредитный лимит<span> ₽ {{ formattedValue }}</span>

      </div>
    <div class="rangeContainer">
<input type="range"
           :min="min"
           :max="max"
           :step="step"
           v-model="value"
    >
    <div class="topRange" ref="topRange">
      <div class="rangeBar"></div>
      <div class="rangeProgress" v-bind:style="{width:rangeProgress + 'px'}"></div>
      <div class="rangeThumb" v-bind:style="{left:rangeProgress + 'px'}" ref="rangeThumb"></div>
    </div>
    </div>
    </div>
    <div id="triangleDown"></div>
    <div class="getMoney">
      <p class="bold">Для получения карты<br>нажмите здесь</p>
      <div class="strelkaposition">
      <svg width="30" height="35" viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'strelka'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.687 33.447c-.084-.25.062-.47.326-.489l1.242-.09a.648.648 0 01.63.42c.083.251-.063.47-.327.49l-1.242.09a.649.649 0 01-.63-.42z" fill="#C4C4C4"/><path d="M15.944 33.629c-.252-.082-.342-.33-.2-.553l.5-.794a.648.648 0 01.712-.257c.252.082.341.33.2.553l-.5.793a.649.649 0 01-.712.258z" fill="#C4C4C4"/><rect width="2.14" height=".993" rx=".497" transform="matrix(.8684 -.49585 .71326 .7009 18.758 31.645)" fill="#C4C4C4"/><rect width="2.063" height="1.033" rx=".517" transform="matrix(.7984 -.60212 .8023 .59692 21.662 29.903)" fill="#C4C4C4"/><rect width="1.973" height="1.076" rx=".538" transform="matrix(.69598 -.71806 .87849 .47777 24.217 27.87)" fill="#C4C4C4"/><rect width="1.879" height="1.117" rx=".559" transform="matrix(.54844 -.83619 .93847 .34537 26.303 25.578)" fill="#C4C4C4"/><rect width="1.797" height="1.15" rx=".575" transform="matrix(.34264 -.93947 .9797 .20048 27.834 23.03)" fill="#C4C4C4"/><rect width="1.753" height="1.167" rx=".584" transform="matrix(.08586 -.9963 .99883 .0483 28.684 20.309)" fill="#C4C4C4"/><rect width="1.763" height="1.164" rx=".582" transform="matrix(-.18214 -.98327 .99464 -.10338 28.783 17.562)" fill="#C4C4C4"/><rect width="1.823" height="1.14" rx=".57" transform="matrix(-.42148 -.90684 .96764 -.25235 28.137 14.833)" fill="#C4C4C4"/><rect width="1.912" height="1.103" rx=".552" transform="matrix(-.60815 -.79382 .91871 -.39492 26.771 12.212)" fill="#C4C4C4"/><rect width="2.006" height="1.061" rx=".53" transform="matrix(-.73758 -.67526 .85261 -.52255 24.822 9.847)" fill="#C4C4C4"/><rect width="2.092" height="1.018" rx=".509" transform="matrix(-.82643 -.56305 .77192 -.63572 22.383 7.743)" fill="#C4C4C4"/><rect width="2.165" height=".98" rx=".49" transform="matrix(-.88798 -.45989 .67826 -.73482 19.55 5.916)" fill="#C4C4C4"/><rect width="2.223" height=".946" rx=".473" transform="matrix(-.93047 -.36638 .57443 -.81856 16.39 4.363)" fill="#C4C4C4"/><rect width="2.267" height=".92" rx=".46" transform="matrix(-.9594 -.28207 .46413 -.88577 13.037 3.112)" fill="#C4C4C4"/><rect width="2.3" height=".899" rx=".45" transform="matrix(-.97893 -.20418 .34844 -.93733 9.518 2.14)" fill="#C4C4C4"/><rect width="2.321" height=".885" rx=".443" transform="matrix(-.9915 -.13016 .22782 -.9737 5.883 1.439)" fill="#C4C4C4"/><rect width="2.333" height=".878" rx=".439" transform="matrix(-.99808 -.06189 .10984 -.99395 2.328 1.017)" fill="#C4C4C4"/></svg>
      </div>
      <a class="get" href="#" v-on:click.prevent="showForm">Отправить заявку</a>
      <p class="number">97%</p>
      <p>вероятность одобрения</p>
    </div>

      </section>
      </div>
      </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'limitScroll',
  data() {
    return {
      value: 10000,
      min:10000,
      max:100000,
      step:1000,
    }
  },
  methods:{
    showForm(){
      if (this.stepForm === 0) {
        this.$store.commit('loadingStatus', true);
          this.$store.commit('incStepForm');
          try {
            // eslint-disable-next-line 
            ym(82222150, 'reachGoal', 'getmoney');
          }
          catch(e){
            console.log(e)
          }
      }      
    }
  },
  computed: {
  
    ...mapState({
      stepForm: state => state.alfaForm.stepForm,
    }),


      rangeProgress() {

        let selectRange = this.value - this.min;
        let selectRangeMax = this.max - this.min;

        if (selectRangeMax === 0) {

          return 0;
          }

        if (this.$refs.topRange != undefined) {
          // let tumbWidth = this.$refs.rangeThumb.clientWidth ;
        let delta = 0
          //let delta = (selectRange < (selectRangeMax / 2)) ? tumbWidth : tumbWidth * (-1);
          let clW = this.$refs.topRange.clientWidth;
          return Math.round(((selectRange * clW) / selectRangeMax) + delta);
        } else {
          return 0;
        }

      },
      formattedValue() {
        return Number(this.value).toLocaleString('ru-RU');
      },
  },
  mounted(){
    this.value = 50000;

  }

}
</script>


<style scoped>

.rangeContainer {position: relative;width: 76vw; /*input range width*/height: 17vw; margin: 0 auto; /*input range height*/
    /*overflow: hidden;*/
}

input[type='range'] {width: 100%;height: 100%;-webkit-appearance: none;opacity: 0;}
input[type=range]::-webkit-slider-thumb {-webkit-appearance: none;height: 25vw;width: 12vw;background-color: red;}
  /* All the same stuff for Firefox */
input[type=range]::-moz-range-thumb {height: 25vw;width: 12vw;cursor: pointer;}
  /* All the same stuff for IE */
input[type=range]::-ms-thumb {height: 25vw;width: 12vw;cursor: pointer;}
.topRange {pointer-events: none;width: 100%; position: absolute;top:0;height: 100%;}
.rangeBar{position: absolute;top: calc(50% - 1vw);left: 0;width: 100%;height: 2vw;background: #D6D8E7;border-radius: 2vw;}
.rangeProgress {position: absolute;top: calc(50% - 1vw);left: 0;height: 2vw;background: linear-gradient(to right, #5F2EEA, #5F2EEA);border-radius: 2vw;}
.rangeThumb {position: absolute;top: 3.6vw;margin-left: -2.8vw;height: 10vw;width: 10vw;border-radius:100%;background: rgba(222, 211, 255, 0.68);cursor: pointer}
.rangeThumb:before{content: '';position: absolute; top:calc(50% - 3vw);left:calc(50% - 3vw);width: 6vw; height: 6vw;background: #5F2EEA;border-radius: 100%;}
.rangeThumb:after{content: '';position: absolute; top:calc(50% - 2vw);left:calc(50% - 2vw);width: 4vw; height:4vw;background: white;border-radius: 100%;}
.getMoney{text-align: center;}
.bold{font-weight: bold; padding-bottom: 5vw;}
.number{font-size: 6vw;font-weight: bold; color: #2A00A2;padding-top: 5vw;padding-top: 10vw;}
.get{padding: 10px 20px;text-decoration: none;color: white;background-color: #5F2EEA;border-radius: 8px; font-size: 4vw;}
span{font-weight: bold; padding-left: 15vw;font-size: 5vw;}
.output{text-align: center; padding-top: 8vw; font-size: 4.4vw;}
#limitBox{ border: 1.8vw solid #F5F6FC;border-radius: 27px; padding-bottom: 10vw; width: 86vw;margin-left: auto; margin-right: auto;}
.limitWrapper{background-color:#F5F6FC; border-top-left-radius: 20px 20px; border-top-right-radius: 20px 20px;}
#triangleDown {	padding-bottom: 10vw; width: 0;height: 0;	border-left: 43vw solid transparent;border-right: 43vw solid transparent;	border-top: 8vw solid #F5F6FC;}

.strelkaposition{position: relative;height: 0;width: 100%;}
.strelkaposition svg{position: absolute;}
.strelka{top: -6vw; left: 67vw;}
#limitBox{margin: -18px auto;}

@media screen and (min-width: 760px) {
.strelka{width: 66px;height: 78px;}
 }

@media screen and (min-width: 1140px) {
#limitBox{display: flex;border: 7px solid #F5F6FC; width: 1090px;;margin-left: auto; margin-right: auto;margin: -45px auto; padding-bottom: 0px; background-color: white;}
.limitWrapper{background-color:#F5F6FC; border-top-left-radius: 20px 20px; border-top-right-radius: 0px 0px; width: 590px;height: 241px;}
#triangleDown { padding-bottom: 153px;; width: 0;height: 0;	border-left: 43vw solid transparent;border-right: 43vw solid transparent;	border-top: 8vw solid #F5F6FC;}
.topRange{width: 550px;height: 50%;}
input[type='range']{width: 550px; height: 50%;}
.output{padding-top: 54px; font-size: 22px; text-align:left; padding-left: 27px;}
span{font-size: 23px;padding-left: 145px; left: 42px; position: relative;}
.bold{font-size: 19px; padding-bottom: 24px;}
.get{font-size: 18px;}
.number{font-size: 30px;padding-top: 15px;}
p{font-size: 15px;}
.strelka{ width: 44px; height: 64px;top: -36px;left: 225px;}
#triangleDown{ border-left: 119px solid transparent;border-right: 119px solid transparent;border-top: 85px solid #F5F6FC; transform: rotate(270deg);height: 155px;padding-bottom: 0px;}
.rangeContainer{width: 550px;height: 282px;padding-left: 0px; margin: 0; margin-left: 12px;  }
.rangeBar{height: 10px; width: 550px;top: calc(50% - 13px);}
.rangeProgress{height: 10px;     top: calc(50% - 13px);}
.rangeThumb:after{width: 26px; height: 26px;top: calc(50% - 13px);left: calc(50% - 13px);}
.rangeThumb:before{top: calc(50% - 15px);left: calc(50% - 15px);width: 30px;height: 30px;}
.rangeThumb{margin-left: -22px;top: calc(50% - 33px); height: 50px;width: 50px;}
.getMoney{ position: relative;right: 88px; top: 34px;}
input[type=range]::-webkit-slider-thumb{width:25px;}
}


</style>
